module.exports = __webpack_public_path__ + "media/images/aloe/icons/categories/house-2006f383b89eac832f570007b175a887.svg";